import Vue from 'vue'

export const altEans = {
    state: {
        altEans: [],
        status: 'idle',
        pagination: null,
        filters: {
            query: {
                type: 'search-input',
                value: '',
                searchParamsTooltip: ['nazwie produktu', 'kodzie EAN']
            },
            alternative_ean: {
                type: 'search-input',
                value: '',
                text: 'Kod lokalny',
                additionalText: 'Kod lokalny'
            },
            available_in_promos: {
                type: 'checkboxes',
                value: [],
                getter: 'getProductTypesForSelect',
                text: 'Typ produktu',
                firstOption: 'Wszystkie',
                singleSelect: true,
                expectedType: 'string',
                disabledLinkGenerator: true
            },
            merchant_id: {
                type: 'checkboxes',
                value: [],
                getter: 'getMerchantsForSelect',
                text: 'Sklepy',
                firstOption: 'Wszystkie',
                expectedType: 'string',
                disabledLinkGenerator: true
            }
        },
        sortOptions: [
            {
                query: 'name',
                label: 'Nazwa'
            }
        ],
        sort: {
            by: 'name',
            direction: 'asc'
        }
    },

    mutations: {
        SET_ALTEANS(state, payload) {
            state.altEans = payload
        },
        SET_ALTEANS_PAGINATION(state, payload) {
            state.pagination = payload
        },
        SET_ALTEANS_STATUS(state, payload) {
            state.status = payload
        },
        SET_ALTEANS_FILTER(state, payload) {
            Vue.set(state.filters[payload.filter], 'value', payload.value)
        },
        RESET_ALTEANS_FILTERS(state, payload) {
            Vue.set(state, 'filters', payload)
        }
    },

    actions: {
        async fetchMerchantAltEans(_, { params, config }) {
            try {
                return await this.$api.get('merchant_alternative_eans', {
                    params,
                    config
                })
            } catch (err) {
                console.log(err)
            }
        },

        async fetchAltEans(_, { params }) {
            try {
                // Fetch products
                const resProducts = await this.$api.get('dict_products', {
                    params
                })

                const { data, status } = resProducts

                if (status !== 200 || !data?.data) {
                    // Check if products were fetched
                    throw new Error(data?.message || 'Error GET dict_products')
                }

                // Fetch alternative eans
                const productIds = data.data.map(p => p.id).join(',')
                const resAltEans = await this.$api.get(
                    'merchant_alternative_eans',
                    {
                        params: {
                            per: 99999,
                            dict_product_id: productIds,
                            merchant_id:
                                params[
                                    'merchant_alternative_eans|merchant_id'
                                ]
                        },
                        config: {
                            noCancel: true
                        }
                    }
                )

                if (resAltEans.status !== 200 || !resAltEans.data?.data) {
                    // Check if alternative eans were fetched
                    throw new Error(resAltEans.data?.message || 'Error GET merchant_alternative_eans')
                }

                // Assign alternative eans to products
                resProducts.data.data.forEach(product => {
                    product.alternative_eans = resAltEans.data.data.filter(
                        ean => ean.dict_product_id === product.id
                    )
                })

                // Return products with alternative eans
                return resProducts
            } catch (err) {
                console.log(err)
            }
        },

        async loadAltEans({ commit, dispatch, getters, state }, payload) {
            try {
                commit('SET_ALTEANS_STATUS', 'loading')

                let params = await dispatch('setFilterQueryParams', {
                    filters: getters.getAltEansFilters
                })

                params.includes = 'image'
                // Removed in #1829
                // params.ean_present = false
                params.main = true

                const fMerchants = state.filters.merchant_id.value
                params[
                    'merchant_alternative_eans|merchant_id'
                ] = fMerchants.length
                    ? fMerchants.join(',')
                    : getters.getAvailableMerchants.map(e => e.id).join(',')

                const fAltEan = state.filters.alternative_ean.value
                params['merchant_alternative_eans|alternative_ean'] =
                    fAltEan || undefined

                if (payload) params = { ...params, ...payload }

                params.sort = state.sort.by
                params.direction = state.sort.direction

                delete params.merchant_id
                delete params.alternative_ean

                const { data } = await dispatch('fetchAltEans', {
                    params
                })

                if (!data?.data?.length) {
                    commit('SET_ALTEANS', [])
                    commit('SET_ALTEANS_PAGINATION', null)
                    return
                }

                commit('SET_ALTEANS', data.data)
                commit('SET_ALTEANS_PAGINATION', data.pagination[0])
            } catch (err) {
                console.log(err)
            } finally {
                commit('SET_ALTEANS_STATUS', 'idle')
            }
        },

        async createAlternativeEan(_, payload) {
            try {
                return await this.$api.post(
                    'merchant_alternative_eans',
                    payload
                )
            } catch (err) {
                console.log(err)
            }
        },

        async updateAltEan(_, { id, alternative_ean }) {
            try {
                return await this.$api.patch(
                    `merchant_alternative_eans/${id}`,
                    {
                        alternative_ean
                    }
                )
            } catch (err) {
                console.log(err)
            }
        },

        async updateAllAltEans({ dispatch }, payload) {
            try {
                const error = []
                const success = []

                for (const product of payload) {
                    let res
                    if (product.id) {
                        res = await dispatch('updateAltEan', {
                            id: product.id,
                            alternative_ean: product.alternative_ean
                        })
                    } else {
                        const params = {
                            dict_product_id: product.dict_product_id,
                            alternative_ean: product.alternative_ean,
                            merchant_id: product.merchant_id
                        }
                        res = await dispatch('createAlternativeEan', params)
                    }

                    if (res.status === 200 || res.status === 201) {
                        success.push(product.id)
                    } else {
                        error.push(product.id)
                    }
                }

                return { success, error }
            } catch (err) {
                console.log(err)
            }
        },

        async deleteAltEan(_, payload) {
            try {
                return await this.$api.delete(
                    `merchant_alternative_eans/${payload}`
                )
            } catch (err) {
                console.log(err)
            }
        },

        async deleteAllAltEans({ dispatch }, payload) {
            try {
                const error = []
                const success = []

                for (const { id } of payload) {
                    const res = await dispatch('deleteAltEan', id)

                    if (res.status === 200 || res.status === 201) {
                        success.push(id)
                    } else {
                        error.push(id)
                    }
                }

                return { success, error }
            } catch (err) {
                console.log(err)
            }
        },

        async checkIfEansExist({ dispatch }, payload) {
            try {
                const errors = []

                for (const altEan of payload) {
                    const { data, status } = await this.$api.get(
                        'merchant_alternative_eans',
                        {
                            params: {
                                includes: 'dict_product,dict_product.image',
                                alternative_ean:
                                    altEan.alternative_ean || undefined,
                                merchant_id:
                                    altEan.merchant_id ||
                                    altEan.merchant?.id ||
                                    undefined
                            },
                            config: {
                                noCancel: true
                            }
                        }
                    )

                    if (status === 200 || status === 201) {
                        if (!data?.data?.length) continue

                        data.data.forEach(p => {
                            errors.push({
                                id: p.id,
                                alternative_ean: p.alternative_ean,
                                name: p.dict_product.name,
                                image: p.dict_product.image,
                                ean: p.dict_product.ean,
                                merchant_id: p.merchant_id
                            })
                        })
                    }
                }

                return errors
            } catch (err) {
                console.log(err)
            }
        },

        removeEanFromStore({ commit, state }, payload) {
            const eans = JSON.parse(JSON.stringify(state.altEans))
            const index = eans.findIndex(ean => ean.id === payload)
            eans.splice(index, 1)
            commit('SET_ALTEANS', eans)
        }
    },

    getters: {
        getAltEans: state => state.altEans,
        getAltEansPagination: state => state.pagination,
        getAltEansStatus: state => state.status,
        getAltEansFilters: state => state.filters,
        areAltEansFiltersApplied: state => {
            const filters = state.filters
            let areApplied = false
            for (const key of Object.keys(filters)) {
                if (filters[key]) {
                    if (Array.isArray(filters[key].value)) {
                        if (filters[key].value.length > 0) {
                            areApplied = true
                            break
                        }
                    } else if (filters[key].value) {
                        areApplied = true
                        break
                    }
                }
            }
            return areApplied
        },
        getProductTypesForSelect: () => {
            return [{
                label: 'Wagowy (kg)',
                value: 'weight'
            },
            {
                label: 'Sztukowy (szt)',
                value: 'piece'
            }]
        }
    }
}
